<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}

.query-title-div {
  width: 90px !important;
}
.topList {
  height: 175px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .topList-div {
    width: 30%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #4182eb;
    border-radius: 22px;
    div {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      &:first-child {
        width: 35%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        p:nth-child(3) {
          font-size: 23px;
        }
      }
      &:last-child {
        flex: 1;
        height: 80%;
        border-left: 1px solid rgba(255, 255, 255, 0.404);
        color: white;
        p {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          box-sizing: border-box;
        }
      }
    }
  }
  .topList-div3 {
    width: 30%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #4182eb;
    border-radius: 22px;
    div {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
      // text-align: center;
      &:first-child {
        width: 50%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        border-right: 1px solid rgba(255, 255, 255, 0.404);
        padding: 20px;
        box-sizing: border-box;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        p:nth-child(3) {
          font-size: 23px;
        }
      }
      &:last-child {
        width: 50%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        padding: 20px;
        box-sizing: border-box;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        p:nth-child(3) {
          font-size: 23px;
        }
      }
    }
  }
}
.reportDiv {
  width: 100%;
  height: 450px;
  overflow: auto;
  // padding: 20px;
  border: 1px solid #e6e8ef;
  margin-top: 20px;
  border-radius: 7px;
  .reportDiv-List {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    .top {
      display: flex;
      div {
        width: 15%;
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #8f9bb3;
        &:last-child {
          font-size: 20px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #4182eb;
          letter-spacing: 1px;
        }
      }
    }
    .list {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .list-left {
        width: 20%;
        // border: 1px solid #e6e8ef;
        border-radius: 14px;
        height: 210px;
        overflow: hidden;
        div:last-child {
          p {
            display: flex;
            justify-content: space-around;
            align-items: center;
            font-size: 16px;
            height: 16px;
            line-height: 16px;
            margin: 20px 0;
            span:nth-child(1) {
              display: block;
              width: 40%;
            }
            span:nth-child(2) {
              display: block;
              width: 20%;
            }
            span:nth-child(3) {
              display: block;
              width: 20%;
            }
          }
        }
      }
      .list-right {
        width: 60%;
        height: 260px;
        // border: 1px solid #e6e8ef;
        border-radius: 14px;
        overflow: hidden;
        .registration-trends {
          width: 100%;
          height: 257px;
        }
      }
      .list-right2 {
        width: 20%;
        height: 180px;
        overflow: hidden;
        p {
          display: flex;
          justify-content: space-around;
          align-items: center;
          font-size: 16px;
          height: 16px;
          line-height: 16px;
          margin: 20px 0;
          span:nth-child(1) {
            display: block;
            width: 20%;
          }
          span:nth-child(2) {
            display: block;
            width: 50%;
            display: flex;
            justify-content: flex-end;
            align-content: center;
          }
          span:nth-child(3) {
            display: block;
            width: 17px;
            height: 17px;
            // background: #bb87f3;
            border-radius: 4px;
          }
          &:nth-child(1) {
            span:nth-child(3) {
              background: #bb87f3;
            }
          }
          &:nth-child(2) {
            span:nth-child(3) {
              background: #22c6be;
            }
          }
          &:nth-child(3) {
            span:nth-child(3) {
              background: #1677ff;
            } 
          }
          &:nth-child(4) {
            span:nth-child(3) {
              background: #4cd533;
            }
          }
          &:nth-child(5) {
            span:nth-child(3) {
              background: #09c5ff;
            }
          }
        }
        
      }
    }
    .to-List {
      width: 100%;
      // height: 60px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}

.blue {
  background: #4182eb !important;
  color: white !important;
  border: none;
}
.gray {
  background: #e7e7e8 !important;
  border: none;
  color: #9ba5ba;
  // color: white !important;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title">活跃用户报表</div>

      <!-- 报表 -->
      <div class="reportDiv">
        <div class="topTitle">
          <div>{{statisDateAll}}</div>
          <div>
            <el-button
              :class="daysChange ? 'blue' : 'gray'"
              type="primary"
              @click="handleDateChange"
              round
              >近七天</el-button
            >
            <el-button
              :class="!daysChange ? 'blue' : 'gray'"
              type="primary"
              @click="handleDateChange"
              round
              >近三十天</el-button
            >
          </div>
        </div>
        <!-- 用户访问 -->
        <div class="reportDiv-List">
          <div class="top">
            <div>活跃用户数</div>
            <div>
              <span>{{ detailInfo.custActiveDto.activeCountAll | numberToCurrency}}</span>
            </div>
          </div>
          <div class="list">
            <div class="list-left">
              <div>
                <p>
                  <span></span>
                  <span>数量</span>
                  <span>占比</span>
                </p>
                <p>
                  <span>挚达APP活跃用户数</span>
                  <span>{{ detailInfo.custActiveDto.activeCountZdApp| numberToCurrency }}</span>
                  <span>{{ detailInfo.custActiveDto.activeRatioZdApp |numFilter}}%</span>
                </p>
                <p>
                  <span>桩到家APP活跃用户数</span>
                  <span>{{ detailInfo.custActiveDto.activeCountZdjApp | numberToCurrency}}</span>
                  <span>{{ detailInfo.custActiveDto.activeRatioZdjApp |numFilter}}%</span>
                </p>
                <p>
                  <span>支付宝小程序活跃用户数</span>
                  <span>{{ detailInfo.custActiveDto.activeCountZdAli | numberToCurrency}}</span>
                  <span>{{ detailInfo.custActiveDto.activeRatioZdAli |numFilter}}%</span>
                </p>
                <p>
                  <span>微信小程序活跃用户数</span>
                  <span>{{
                    detailInfo.custActiveDto.activeCountZdWeChat| numberToCurrency
                  }}</span>
                  <span
                    >{{ detailInfo.custActiveDto.activeRatioZdWeChat |numFilter}}%</span
                  >
                </p>
              </div>
            </div>
            <div class="list-right">
              <div class="registration-trends" id="RegistrationTrends"></div>
            </div>
            <div class="list-right2">
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange1"
                    v-model="checkbox1"
                  ></el-checkbox
                ></span>
                <span>活跃总数</span>
                <span></span>
              </p>
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange2"
                    v-model="checkbox2"
                  ></el-checkbox
                ></span>
                <span>挚达APP活跃数</span>
                <span></span>
              </p>
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange3"
                    v-model="checkbox3"
                  ></el-checkbox
                ></span>
                <span>桩到家APP活跃数</span>
                <span></span>
              </p>
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange4"
                    v-model="checkbox4"
                  ></el-checkbox
                ></span>
                <span>支付宝小程序活跃数</span>
                <span></span>
              </p>
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange5"
                    v-model="checkbox5"
                  ></el-checkbox
                ></span>
                <span>微信小程序活跃数</span>
                <span></span>
              </p>
             
            </div>
          </div>
          <div class="to-List">
            <el-button type="primary" @click="toCustActivePage"
              >数据列表</el-button
            >
          </div>
        </div>
      </div>
      <!-- 报表 -->
      <div class="reportDiv">
        <div class="topTitle">
          <div>{{signInStatisDateAll}}</div>
          <div>
            <el-button
              :class="daysChange ? 'blue' : 'gray'"
              type="primary"
              @click="handleSignInChange"
              round
              >近七天</el-button
            >
            <el-button
              :class="!daysChange ? 'blue' : 'gray'"
              type="primary"
              @click="handleSignInChange"
              round
              >近三十天</el-button
            >
          </div>
        </div>
        <!-- 用户注册数 -->
        <div class="reportDiv-List">
          <div class="top">
            <div>签到用户数</div>
            <div>
              <span>{{ detailInfo.custSignInDto.signInCountAll | numberToCurrency}}</span>
            </div>
          </div>
          <div class="list">
            <div class="list-left">
              <div>
                <p>
                  <span></span>
                  <span>数量</span>
                  <span>占比</span>
                </p>
                <p>
                  <span>挚达APP签到数</span>
                  <span>{{ detailInfo.custSignInDto.signInCountZdApp | numberToCurrency}}</span>
                  <span>{{ detailInfo.custSignInDto.signInRatioZdApp |numFilter}}%</span>
                </p>
                <p>
                  <span>支付宝小程序签到数</span>
                  <span>{{ detailInfo.custSignInDto.signInCountZdAli | numberToCurrency}}</span>
                  <span>{{ detailInfo.custSignInDto.signInRatioZdAli |numFilter}}%</span>
                </p>
                <p>
                  <span>微信小程序签到数</span>
                  <span>{{
                    detailInfo.custSignInDto.signInCountZdWeChat| numberToCurrency
                  }}</span>
                  <span
                    >{{ detailInfo.custSignInDto.signInRatioZdWeChat |numFilter}}%</span
                  >
                </p>
              </div>
            </div>
            <div class="list-right">
              <div class="registration-trends" id="bindingTrend"></div>
            </div>
            <div class="list-right2">
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange6"
                    v-model="checkbox6"
                  ></el-checkbox
                ></span>
                <span>签到总数</span>
                <span></span>
              </p>
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange7"
                    v-model="checkbox7"
                  ></el-checkbox
                ></span>
                <span>挚达APP签到数</span>
                <span></span>
              </p>
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange8"
                    v-model="checkbox8"
                  ></el-checkbox
                ></span>
                <span>支付宝小程序签到数</span>
                <span></span>
              </p>
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange9"
                    v-model="checkbox9"
                  ></el-checkbox
                ></span>
                <span>微信小程序签到数</span>
                <span></span>
              </p>
            </div>
          </div>
          <div class="to-List">
            <el-button type="primary" @click="toCustRegistPage"
              >数据列表</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
// import dateUtil from "../../../utils/dateUtils";
import { EleResize } from "../../../../config/esresize";
import * as echarts from "echarts";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      daysChange: true,
      signInChange: true,
      checkbox1: true,
      checkbox2: false,
      checkbox3: false,
      checkbox4: false,
      checkbox5: false,
      checkbox6: true,
      checkbox7: false,
      checkbox8: false,
      checkbox9: false,
      detailInfo: {
        custActiveDto: {
          
          activeCountAll: 0,
          activeCountZdAli: 0,
          activeCountZdApp: 0,
          activeCountZdWeChat: 0,
          activeCountZdjApp: 0,
          activeRatioZdAli: 0,
          activeRatioZdApp: 0,
          activeRatioZdWeChat: 0,
          activeRatioZdjApp: 0,
          statisDate:"",
        },
        custSignInDto: {
          
          signInCountAll: 0,
          signInCountZdAli: 0,
          signInCountZdApp: 0,
          signInCountZdWeChat: 0,
          signInCountZdjApp: 0,
          signInRatioZdAli: 0,
          signInRatioZdApp: 0,
          signInRatioZdWeChat: 0,
          signInRatioZdjApp: 0,
          statisDate:"",
        },
        custActiveList: [],
        custSignInList: [],
      },
      startDate: "",
      endDate: "",
      // 活跃用户日期，总数
      custActiveListStatisDate: [],
      custActiveListActiveCountAll: [],
      custActiveCountZdApp:[],
      custActiveCountZdjApp:[],
      custActiveCountZdAli:[],
      custActiveCountZdWeChat:[],
      custActiveCountChangeList:[],
      countColor:'#bb87f3',
      // 签到用户日期，总数
      custSignInListStatisDate: [],
      custSignInListField_3: [],
      custSignInCountZdApp:[],
      custSignInCountZdAli:[],
      custSignInCountZdWeChat:[],
      custSignInCountChangeList:[],
      custSignInColor:'#bb87f3',
      statisDateAll:'',
      signInStatisDateAll:'',
    };
  },
  methods: {
    // 判断页面路由是否存在手机号码/站点编号
    init() {
      // 获取用户注册趋势
      // this.getRegistrationTrends();
    },
    //选择系统日期时间
    handleDateChange(val) {
      console.log(this.daysChange);
      this.daysChange = !this.daysChange;
      // this.checkbox1 = false
      this.getData();
      this.statisDateAll = `${this.startDate}~${this.endDate}`
    },
    handleSignInChange(val) {
      console.log(this.daysChange);
      this.signInChange = !this.signInChange;
      // this.checkbox6 = false
      this.getSignInData();
      this.signInStatisDateAll = `${this.startDate}~${this.endDate}`
    },
    toCustActivePage() {
      let _ = this;
      var url = _.$router.resolve({
        name: "activeUserList",
        query: { daysChange: _.daysChange},
      });
      window.open(url.href, "_blank");
    },
    toCustRegistPage() {
      let _ = this;
      var url = _.$router.resolve({
        name: "checkUserList",
        query: { signInChange: _.signInChange},
      });
      window.open(url.href, "_blank");
    },
    getWeek() {
      let time = new Date().getTime();
      let endTime = time - 6 * 24 * 3600 * 1000;
      this.startDate = this.$dayjs(endTime).format("YYYY-MM-DD");
      this.endDate = this.$dayjs(time).format("YYYY-MM-DD");
      console.log(this.startDate); // 开始时间
      console.log(this.endDate); // 结束时间
    },
    getMonth() {
      let time = new Date().getTime();
      let now = new Date(); // 当前日期
      let nowMonth = now.getMonth(); // 当前月
      let nowYear = now.getFullYear(); // 当前年
      let monthStartDate = new Date(nowYear, nowMonth, 1);
      let monthEndDate = new Date(nowYear, nowMonth + 1, 0);
      this.startDate = this.$dayjs(monthStartDate).format("YYYY-MM-DD");
      this.endDate = this.$dayjs(monthEndDate).format("YYYY-MM-DD");
    },
    getData() {
      let _ = this;
      if (_.daysChange) {
        _.getWeek()
      }else{
        this.getMonth();
      }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custActiveListStatisDate = []
        _.custActiveListActiveCountAll = []
        _.custActiveCountZdApp=[]
        _.custActiveCountZdjApp=[]
        _.custActiveCountZdAli=[]
        _.custActiveCountZdWeChat=[]
        _.$H.post(_, _.$A.operateStatis.custActive, obj).then((res) => {
          _.detailInfo = res.data.data;
          // 活跃用户
          _.detailInfo.custActiveList.forEach((item) => {
            _.custActiveListStatisDate.push(item.statisDate);
            _.custActiveListActiveCountAll.push(item.activeCountAll);
            if (_.checkbox1) {
              _.custActiveListActiveCountAll.push(item.activeCountAll);
          }else{
            _.custActiveListActiveCountAll = []
          }
          if (_.checkbox2) {
            _.custActiveCountZdApp.push(item.activeCountZdApp);
          }
          if (_.checkbox3) {
            _.custActiveCountZdjApp.push(item.activeCountZdjApp);
          }
          if (_.checkbox4) {
            _.custActiveCountZdAli.push(item.activeCountZdAli);
          }
          if (_.checkbox5) {
            _.custActiveCountZdWeChat.push(item.activeCountZdWeChat);
          }
          });
          _.getRegistrationTrends()
        });
     
      
    },
    getSignInData() {
      let _ = this;
      
      if (_.signInChange) {
        _.getWeek();
      }else{
        this.getMonth();
      }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custSignInListStatisDate = []
        _.custSignInListField_3 = []
        _.custSignInCountZdApp=[]
        _.custSignInCountZdAli=[]
        _.custSignInCountZdWeChat=[]
        _.$H.post(_, _.$A.operateStatis.custSignInChart, obj).then((res) => {
          _.detailInfo = res.data.data;

          // 签到用户
          _.detailInfo.custSignInList.forEach((item) => {
            _.custSignInListStatisDate.push(item.statisDate);
            _.custSignInListField_3.push(item.field_3);
            if (_.checkbox6) {
              _.custSignInListField_3.push(item.field_3);
          }else{
            _.custSignInListField_3 = []
          }
          if (_.checkbox7) {
            _.custSignInCountZdApp.push(item.signInCountZdApp);
          }
          if (_.checkbox8) {
            _.custSignInCountZdAli.push(item.signInCountZdAli);   
          }
          if (_.checkbox9) {
            _.custSignInCountZdWeChat.push(item.signInCountZdWeChat);
          }
          });
          _.getBindingTrend()
        });
     
    },




    handleCheckboxChange1() {
      let _ = this;
      if (_.checkbox1) {
        _.checkbox2 = false
        _.custActiveCountZdApp = []
        _.checkbox3 = false
        _.custActiveCountZdjApp = []
        _.checkbox4 = false
        _.custActiveCountZdAli = []
        _.checkbox5 = false
        _.custActiveCountZdWeChat = []
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custActiveListActiveCountAll =[]
        _.custActiveListStatisDate = []
        _.$H.post(_, _.$A.operateStatis.custActive, obj).then((res) => {
          _.detailInfo = res.data.data;
          // 用户绑定
          _.detailInfo.custActiveList.forEach((item) => {
            // 挚达App绑定
             _.custActiveListStatisDate.push(item.statisDate);
            _.custActiveListActiveCountAll.push(item.activeCountAll);
          });
          _.getRegistrationTrends()
        });
      }else{
        _.custActiveListActiveCountAll =[]
        _.getRegistrationTrends()
      }
    },
    handleCheckboxChange2() {
      let _ = this;

      if (_.checkbox2) {
        _.checkbox1 = false
        _.custActiveListActiveCountAll =[]
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custActiveCountZdApp = []
        _.custActiveListStatisDate = []
        _.$H.post(_, _.$A.operateStatis.custActive, obj).then((res) => {
          _.detailInfo = res.data.data;

          _.detailInfo.custActiveList.forEach((item) => {

            _.custActiveListStatisDate.push(item.statisDate);
            _.custActiveCountZdApp.push(item.activeCountZdApp);
            
          });
          _.getRegistrationTrends()
        });
      }else{
        _.custActiveCountZdApp = []
        _.getRegistrationTrends()
      }
    },
   
    handleCheckboxChange3() {
      let _ = this;
      if (_.checkbox3) {
        _.checkbox1 = false
        _.custActiveListActiveCountAll =[]
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custActiveCountZdjApp = []
        _.custActiveListStatisDate = []
        _.$H.post(_, _.$A.operateStatis.custActive, obj).then((res) => {
          _.detailInfo = res.data.data;
          // 用户绑定
          _.detailInfo.custActiveList.forEach((item) => {
            // 桩到家App绑定
             _.custActiveListStatisDate.push(item.statisDate);
            _.custActiveCountZdjApp.push(item.activeCountZdjApp);
            
          });
          _.getRegistrationTrends()
        });
      }else{
        _.custActiveCountZdjApp = []
        _.getRegistrationTrends()
      }
    },
    handleCheckboxChange4() {
      let _ = this;
     
      if (_.checkbox4) {
        _.checkbox1 = false
        _.custActiveListActiveCountAll =[]
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custActiveCountZdAli = []
        _.custActiveListStatisDate = []
        _.$H.post(_, _.$A.operateStatis.custActive, obj).then((res) => {
          _.detailInfo = res.data.data;
          // 用户绑定
          _.detailInfo.custActiveList.forEach((item) => {
            // 支付宝绑定
             _.custActiveListStatisDate.push(item.statisDate);
            _.custActiveCountZdAli.push(item.activeCountZdAli);
           
          });
          _.getRegistrationTrends()
        });
      }else{
        _.custActiveCountZdAli = []
        _.getRegistrationTrends()
      }
    },
    handleCheckboxChange5() {
      let _ = this;

      if (_.checkbox5) {
        _.checkbox1 = false
        _.custActiveListActiveCountAll =[]
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custActiveCountZdWeChat = []
        _.custActiveListStatisDate = []
        _.$H.post(_, _.$A.operateStatis.custActive, obj).then((res) => {
          _.detailInfo = res.data.data;
          // 用户绑定
          _.detailInfo.custActiveList.forEach((item) => {
            // 微信绑定
             _.custActiveListStatisDate.push(item.statisDate);
            _.custActiveCountZdWeChat.push(item.activeCountZdWeChat);
          });
          
        });
      }else{
        _.custActiveCountZdWeChat = []
        _.getRegistrationTrends()
      }
    },
   



    handleCheckboxChange6() {
      let _ = this;
      if (_.checkbox6) {
        _.checkbox7 = false
        _.custSignInCountZdApp =[]
        _.checkbox8 = false
        _.custSignInCountZdAli = []
        _.checkbox9 = false
        _.custSignInCountZdWeChat = []
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custSignInListField_3 = []
        _.custSignInListStatisDate = []
        _.$H.post(_, _.$A.operateStatis.custActive, obj).then((res) => {
          _.detailInfo = res.data.data;
          // 用户绑定
          _.detailInfo.custSignInList.forEach((item) => {
            // 绑定
            _.custSignInListStatisDate.push(item.statisDate);
            _.custSignInListField_3.push(item.field_3);
            _.custSignInColor='#bb87f3'
          });
          _.getBindingTrend()
        });
      }else{
        _.custSignInListField_3 = []
        _.getBindingTrend()
      }
    },
    handleCheckboxChange7() {
      let _ = this;

      if (_.checkbox7) {
        _.checkbox6 = false
        _.custSignInListField_3 = []
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custSignInCountZdApp =[]
        _.custSignInListStatisDate = []
        _.$H.post(_, _.$A.operateStatis.custActive, obj).then((res) => {
          _.detailInfo = res.data.data;
          // 用户绑定
          _.detailInfo.custSignInList.forEach((item) => {
            // 挚达App绑定
            _.custSignInListStatisDate.push(item.statisDate);
            _.custSignInCountZdApp.push(item.signInCountZdApp);
          });
          _.getBindingTrend()
        });
      }else{
        _.custSignInListField_3 = []
        _.getBindingTrend()
      }
    },
    handleCheckboxChange8() {
      let _ = this;

      if (_.checkbox8) {
        _.checkbox6 = false
        _.custSignInListField_3 = []
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custSignInCountZdAli = []
        _.custSignInListStatisDate = []
        _.$H.post(_, _.$A.operateStatis.custActive, obj).then((res) => {
          _.detailInfo = res.data.data;
          // 用户绑定
          _.detailInfo.custSignInList.forEach((item) => {
            // 桩到家App绑定
            _.custSignInListStatisDate.push(item.statisDate);
            _.custSignInCountZdAli.push(item.signInCountZdAli);   
          });
          _.getBindingTrend()
        });
      }else{
        _.custSignInCountZdAli = []
        _.getBindingTrend()
      }
    },
    handleCheckboxChange9() {
      let _ = this;

      if (_.checkbox9) {
        _.checkbox6 = false
        _.custSignInListField_3 = []
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.custSignInCountZdWeChat = []
        _.custSignInListStatisDate = []
        _.$H.post(_, _.$A.operateStatis.custActive, obj).then((res) => {
          _.detailInfo = res.data.data;
          // 用户绑定
          _.detailInfo.custSignInList.forEach((item) => {
            // 支付宝绑定
            _.custSignInListStatisDate.push(item.statisDate);
            _.custSignInCountZdWeChat.push(item.signInCountZdWeChat);
          });
          _.getBindingTrend()
        });
      }else{
        _.custSignInCountZdWeChat = []
        _.getBindingTrend()
      }
    },
    //表格详情
    toDetail(val) {
      let _ = this;
      var url = _.$router.resolve({ name: "orderDetail", query: { id: val } });
      window.open(url.href, "_blank");
    },
    // 活跃用户
    getRegistrationTrends() {
      // 基于准备好的dom，初始化echarts实例
      let changeChart = this.$echarts.init(
        document.getElementById("RegistrationTrends")
      );
      // 绘制图表
      changeChart.setOption({
        tooltip: {
          trigger: "axis",
          // backgroundColor:'transparent',
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#f6eefd", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "#dec8f5", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#cfabf7", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          data: this.custActiveListStatisDate,
        },
        yAxis: {
          type: "value",
          max: 1000, //最大值
          min: 0, //最小值
          interval: 500, //间隔

          //坐标轴最大值、最小值、强制设置数据的步长间隔
          // interval: 5,
          // axisLabel: {
          //     //y轴上带的单位
          //     formatter: '{value}'
          // },
          //轴线
          axisLine: {
            show: true,
          },
          // //分割线
          // splitLine: {
          //     show: false
          // }
        },
        series: [
          {
            data: this.custActiveListActiveCountAll,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: '#22c6be', //改变折线点的颜色
                lineStyle: {
                  color: '#22c6be', //改变折线颜色
                },
              },
            },
          },
          {
            data: this.custActiveCountZdApp,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: '#bb87f3', //改变折线点的颜色
                lineStyle: {
                  color: '#bb87f3', //改变折线颜色
                },
              },
            },
          },
          {
            data: this.custActiveCountZdjApp,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: '#1677ff', //改变折线点的颜色
                lineStyle: {
                  color: '#1677ff', //改变折线颜色
                },
              },
            },
          },
          {
            data: this.custActiveCountZdAli,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: '#4cd533', //改变折线点的颜色
                lineStyle: {
                  color: '#4cd533', //改变折线颜色
                },
              },
            },
          },
          {
            data: this.custActiveCountZdWeChat,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: '#09c5ff', //改变折线点的颜色
                lineStyle: {
                  color: '#09c5ff', //改变折线颜色
                },
              },
            },
          },
        ],
      });
      setTimeout(() => {
        window.addEventListener("resize", function() {
          changeChart.resize();
        });
      }, 500);
    },
    // 签到用户
    getBindingTrend() {
      // 基于准备好的dom，初始化echarts实例
      let changeChart = this.$echarts.init(
        document.getElementById("bindingTrend")
      );
      // 绘制图表
      changeChart.setOption({
        tooltip: {
          trigger: "axis",
          // backgroundColor:'transparent',
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#e0ecff", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "#d1e5ff", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#3f8fff", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          data: this.custSignInListStatisDate,
        },
        yAxis: {
          type: "value",
          max: 1000, //最大值
          min: 0, //最小值
          interval: 500, //间隔

          //坐标轴最大值、最小值、强制设置数据的步长间隔
          // interval: 5,
          // axisLabel: {
          //     //y轴上带的单位
          //     formatter: '{value}'
          // },
          //轴线
          axisLine: {
            show: true,
          },
          // //分割线
          // splitLine: {
          //     show: false
          // }
        },
      //   _.custSignInListField_3 = []
      //   _.custSignInCountZdApp=[]
      // _.custSignInCountZdAli=[]
      // _.custSignInCountZdWeChat=[]
        series: [
          {
            data: this.custSignInListField_3,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: '#22c6be', //改变折线点的颜色
                lineStyle: {
                  color: '#22c6be', //改变折线颜色
                },
              },
            },
          },
          {
            data: this.custSignInCountZdApp,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: '#bb87f3', //改变折线点的颜色
                lineStyle: {
                  color: '#bb87f3', //改变折线颜色
                },
              },
            },
          },
          {
            data: this.custSignInCountZdAli,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: '#1677ff', //改变折线点的颜色
                lineStyle: {
                  color: '#1677ff', //改变折线颜色
                },
              },
            },
          },
          {
            data: this.custSignInCountZdWeChat,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: '#4cd533', //改变折线点的颜色
                lineStyle: {
                  color: '#4cd533', //改变折线颜色
                },
              },
            },
          },
        ],
      });
      setTimeout(() => {
        window.addEventListener("resize", function() {
          changeChart.resize();
        });
      }, 500);
    },

    // echarts 实例
    drawECharts(dom, option) {
      let myChart = this.$echarts.init(document.getElementById(dom));
      let resizeDiv = document.getElementById(dom);
      resizeDiv.removeAttribute("_echarts_instance_");
      // 绘制图表
      myChart.setOption(option);
      let listener = () => {
        myChart.resize();
      };
      EleResize.on(resizeDiv, listener);
    },
  },
  mounted() {
    this.init();
    this.getData();
    this.getSignInData();
    this.statisDateAll = `${this.startDate}~${this.endDate}`
    this.signInStatisDateAll = `${this.startDate}~${this.endDate}`
    // this.getRegistrationTrends();
    // this.getBindingTrend();
  },
};
</script>
